import Vue from "vue";

export default {
    recuperarGrupos() {
        return Vue.axios.get("grupo");
    }
}